import {all, fork} from 'redux-saga/effects'
import watchCurrentUser from './currentUser';
import watchToastifyNotification from "./toastifyNotifications";
import watchArticleComment from "./comment/article.comment";
import watchMediaComment from "./comment/media.comment";
import watchStatusComment from './comment/status.comment';
import watchArticle from "./article";
import watchMedia from "./media";
import watchTopic from "./topic";
import watchFollows from "./follows";
import watchFriend from "./friend";
import watchLike from "./like";
import watchStory from './story';
import watchAlbum from "./album";
import watchWarning from "./warning";
import watchFriendRequest from "./friendRequest";
import watchTopicComment from './topicComment';
import watchTopicComments from './topicComments';
import watchSubComment from "./subComments";
import watchTimelineStatus from "./timelineSatus";
import watchTimelineComment from "./timelineComments";
import watchAlbumMedia from "./albumMedias";
import watchUserQuestion from "./userQuestion";
import watchUserCommentstoModerate from "./userCommentsToModerate";
import watchNotificationsFetching from "./userNotifications";
import watchRooms from "./rooms";
import watchRoomMessage from "./roomMessage";
import watchLogin from './login';
import watchSignup from './signup';
import watchReportingComment from './reportingComment';
import watchConfirmEmail from "./confirmEmail";

const sagas = [
    watchSignup,
    watchLogin,
    watchCurrentUser,
    watchArticleComment,
    watchMediaComment,
    watchStatusComment,
    watchTimelineComment,
    watchSubComment,
    watchUserCommentstoModerate,

    watchArticle,
    watchMedia,
    watchAlbumMedia,
    watchFriend,
    watchFriendRequest,
    watchTopic,
    watchTopicComments,
    watchTopicComment,
    watchFollows,
    watchLike,
    watchStory,
    watchAlbum,
    watchWarning,
    watchTimelineStatus,
    watchUserQuestion,
    watchNotificationsFetching,
    watchToastifyNotification,
    watchRooms,
    watchRoomMessage,
    watchReportingComment,
    watchConfirmEmail
];

function* rootSaga() {
    yield all(sagas.map(saga => fork(saga)));
}

export default rootSaga;